"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tab = void 0;
var tslib_1 = require("tslib");
var tabs_1 = require("@reach/tabs");
var react_1 = tslib_1.__importStar(require("react"));
var react_use_1 = require("react-use");
var tab_1 = require("../styled/tab");
var tabs_2 = require("../tabs");
var Tab = function (_a) {
    var _b;
    var children = _a.children, index = _a.index, tabsRef = _a.tabsRef;
    var _c = (0, react_1.useContext)(tabs_2.TabsContext), pattern = _c.pattern, isInverse = _c.isInverse;
    var selectedIndex = (0, tabs_1.useTabsContext)().selectedIndex;
    var tabRef = (0, react_1.useRef)(null);
    var intersection = (0, react_use_1.useIntersection)(tabRef, {
        root: tabsRef === null || tabsRef === void 0 ? void 0 : tabsRef.current,
        rootMargin: '0px',
        threshold: 1,
    });
    (0, react_1.useEffect)(function () {
        var _a;
        if (selectedIndex === index &&
            intersection &&
            (intersection === null || intersection === void 0 ? void 0 : intersection.intersectionRatio) < 1) {
            (_a = tabRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                block: 'nearest',
                inline: 'nearest',
                behavior: 'smooth',
            });
        }
        // run the useEffect when the intersection root has been defined ie. has a height,
        // for the initial scroll when the component loads
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedIndex, (_b = intersection === null || intersection === void 0 ? void 0 : intersection.rootBounds) === null || _b === void 0 ? void 0 : _b.height]);
    return (react_1.default.createElement(tab_1.Tab, { pattern: pattern, "$isInverse": isInverse, ref: tabRef }, children));
};
exports.Tab = Tab;
//# sourceMappingURL=tab.js.map